import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import LoginHeader from '../Layout/LoginHeader';
import image from "../Images/bg.jpg";
import HttpClient from '../utils/HttpClient';

const ForgotPassword = () => {

    const navigate = useNavigate()
    const [email, setEmail] = useState("")
    //update popup end
    const handleForgetPassword = async () => {
        // navigate('/resetPassword', { state: { email: email } });
        // return
        console.log("ERT16", email);
        const res = await HttpClient.requestData("forget-password", "POST", { emailId: email });
        
        if (res && res?.status) {
            navigate('/resetPassword', { state: { email: email } });
        }
    };


    return (
        <>
            <section className="authenSec">
                <div className="authenSecInn">
                    <div className="container">
                        <div className="authenSecInnDiv">
                            <div className="authenSecForm">
                                <div className="authenSecTop">
                                    <div className='forgetFig'>
                                    </div>
                                    <h4>Reset Password</h4>
                                    <p>Please enter your username or email address.
                                        The password will be emailed to you.</p>
                                </div>

                                <div className="authenSecBtm">
                                    <form>
                                        <div className="form-group">
                                            <input type="email" placeholder='Email Id'
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                            />
                                        </div>
                                        {/* <Link to='/resetPassword' className='homeloginBtn'>Send</Link> */}
                                        <button type='button' className='homeloginBtn'
                                        onClick={handleForgetPassword}
                                        >Send</button>
                                    </form>
                                </div>

                            </div>
                            <div className="authenSecImg">
                                <img src={image} alt="img" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ForgotPassword